import { configureStore } from '@reduxjs/toolkit';
import ReduxSlice from './Slice';

export const store = configureStore({
	reducer: {
		festiv: ReduxSlice,
	},
});
